import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ExtendedProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read-helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

@Component({
    selector: 'sh-double-field',
    templateUrl: './double-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShDoubleInputFieldComponent extends ShSimpleInputFieldComponent {
    public readonly DOUBLE_MAX_VALUE: number = 1.7976931348623157e308;
    public readonly DOUBLE_MIN_VALUE: number = -this.DOUBLE_MAX_VALUE;

    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
    }

    init(profileField: ExtendedProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const value = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedDoubleFieldValue(profileField.FieldDefinition, records);
        control.setValue(value);
    }
}
